import { useState } from 'react';
import { Services } from '../services';

export const useEtatDemande = () => {
    const [id, setId] = useState('');
	const [libelle, setLibelle] = useState('');
	

    const [errors, setErrors] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);

    const getEtatDemande = (etatdemandeId, signal) => {        
        return Services.EtatDemandeService.getById(etatdemandeId, signal)
        .then(response => {
            fillEtatDemande(response.etatdemande);
            setIsDisabled(false);
        });
    }

    const createEtatDemande = signal => {
        const payload = {
            libelle,
		
        };

        return Services.EtatDemandeService.create(JSON.stringify(payload), signal);
    }
    const updateEtatDemande = (etatdemandeId, signal) => {
        const payload = {
            libelle,
		
        };

        return Services.EtatDemandeService.update(etatdemandeId, JSON.stringify(payload), signal);
    }
    const deleteEtatDemande = (etatdemandeId, signal) => {
        return Services.EtatDemandeService.destroy(etatdemandeId, signal);
    }
    const fillEtatDemande = (etatdemande) => {
        setId(etatdemande.id);
        setLibelle(etatdemande.libelle ?? '');
		
    }
    const emptyEtatDemande = () => {
        setId('');
        setLibelle('');
		
    }

    return {
        id,
        libelle,
		
        errors,
        isDisabled,
        setLibelle,
		
        setId,
        setErrors,
        setIsDisabled,
        getEtatDemande,
        createEtatDemande,
        updateEtatDemande,
        deleteEtatDemande,
        fillEtatDemande,
        emptyEtatDemande
    };
}